import React from 'react';
import classes from './Greeting.module.css';
import {Typography, Box, Divider} from '@mui/material';
import {BasicContainer} from '../../UI/ContentContainer';
import Grid from '@mui/material/Unstable_Grid2';
import TextContent from '../../UI/TextContent';
import hand_shake from '../../../assets/img/hand_shake.jpg';
import MetaTags from '../../MetaTags/MetaTags';

const Greeting = () => {
    return (
        <BasicContainer>
            <MetaTags
                title="인사말"
                description="저희 드림안전센터(주)를 찾아주셔서 감사합니다."
                ogtitle="드림산업안전센터(주)-인사말"
                ogdescription="저희 드림안전센터(주)를 찾아주셔서 감사합니다."
            />
            <TextContent maxWidth="lg">
                <Grid container>
                    <Grid md={6}>
                        <Box className={classes.image} style={{backgroundColor: 'lightgray', width: '100%', height: '100%'}}>
                        </Box>
                    </Grid>

                    <Grid md={6}>
                        <Box paddingX={5}>
                            <Typography variant="h4" component="h2" sx={{textAlign: "center"}}>안녕하세요</Typography>
                            <Typography variant="contentTitle" component="h5" textAlign="center">드림산업안전센터를 찾아주셔서 감사합니다.</Typography>
                            <Divider sx={{ margin: '20px 0' }}/>
                            <Box sx={{textAlign: "center", display: "flex", justifyContent: "center"}}>
                                <Typography variant="description" textAlign="left" sx={{lineHeight: 2, letterSpacing: 1}}>
                                    저희 <Typography variant="h6" component="span">드림산업안전센터(주)</Typography>는 다년간의 현장 경험과 전문화된 기술력을 바탕으로
                                    안전관리위탁, 회원관리, 유해위험방지계획서 컨설팅, 위험성평가 컨설팅, 근골격계 유해요인조사, 중대재해처벌법 관련
                                    안전보건체계 구축 컨설팅등 여러가지의 사업을 수행하고 있습니다.
                                    저희 회사를 믿고 맡겨주시면
                                    최상의 결과를 얻을수 있도록 최선을 다하겠습니다.<br/>
                                    감사합니다
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </TextContent>
        </BasicContainer>
    )
}

export default Greeting;